var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#684FFB",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3185 6.39834L11.887 5.51609L9.51071 0.399008C9.45914 0.280108 9.37566 0.179206 9.27028 0.108428C9.1649 0.0376495 9.0421 0 8.91664 0C8.79118 0 8.66838 0.0376495 8.563 0.108428C8.45762 0.179206 8.37414 0.280108 8.32257 0.399008L5.94629 5.51609L0.514793 6.39834C0.382331 6.40657 0.257365 6.46498 0.163533 6.56253C0.0697004 6.66007 0.0135109 6.78999 0.00559267 6.9277C-0.0195415 7.1764 0.0405661 7.42635 0.175326 7.6335L4.07922 11.5154L3.23054 17.1619C3.21307 17.3013 3.23605 17.4429 3.29653 17.5687C3.35701 17.6944 3.45224 17.7985 3.57001 17.8677C3.66347 17.953 3.7836 18 3.90797 18C4.03234 18 4.15246 17.953 4.24592 17.8677L8.99847 15.2209L13.751 17.8677H14.0935C14.2602 17.8677 14.433 17.8677 14.433 17.6912C14.5366 17.6073 14.6208 17.5003 14.6795 17.3782C14.7382 17.2561 14.77 17.1219 14.7725 16.9854L13.9238 11.339L17.8277 7.45705C17.9604 7.24905 18.0194 6.9995 17.9944 6.75125C17.8089 6.56481 17.5731 6.44168 17.3185 6.39834Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedStar);
export default __webpack_public_path__ + "static/media/selectedStar.d7f1b3d7640f06cc94e80bff24929905.svg";
export { ForwardRef as ReactComponent };